// extracted by mini-css-extract-plugin
module.exports = {"waterfall":"_10809","item":"_2605","top":"_7728","img":"_2994","text":"_5720","name":"_8600","packageContent":"_18121","opr":"_8312","saleOut":"_14245","bottom":"_12700"};